module.exports = __webpack_public_path__ + "static/media/8.a84b5557.JPG";